import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as actionsSite } from '../../redux/actions/site';
import { actions as actionsAuth } from '../../redux/actions/auth';
import { Link, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { login } from '../../services/auth';
import { ID_LAST_ROUTE } from '../../config/constants';
import './Header.scss';
import avatar from './../../assets/avatares/meio_pasta_preta.png';

const Header = props => {

    const { register, handleSubmit, reset } = useForm();
    const profile = useSelector(state => state.auth.profile);
    
    const history = useHistory();
    const dispatch = useDispatch();

    const sendData = async data => {
        dispatch(actionsSite.setLoadingMsg('Aguarde...'));
        const res = await login(data);
        if (!res.erro) {
            await dispatch(actionsAuth.setProfileByToken());
            dispatch(actionsSite.setLoadingMsg(''));
            //dispatch(actionsAuth.setToken(getToken()));
            const rotaPrivada = localStorage.getItem(ID_LAST_ROUTE);
            // if (rotaPrivada) {
            //     localStorage.removeItem(ID_LAST_ROUTE);
            //     history.push(rotaPrivada);
            // } else {
                history.push('/painel/home');
            //}
        } else {
            dispatch(actionsSite.setLoadingMsg(res.msg));
            reset({})
            setTimeout(() => {
                dispatch(actionsSite.setLoadingMsg(''));
            }, 3000);
        }
    }

    const logout = () => {
        dispatch(actionsAuth.unsetToken());
        dispatch(actionsAuth.unsetProfile());
        history.push("/");
    }

    return (
        <div className="header">
            <div className="container">
                <div className="logo">
                    <Link to="/">
                        <div className="brand">Leka Catálogos</div>
                        <div className="slogan">Muito mais que uma distribuidora</div>
                    </Link>
                </div>
                {!profile._id &&
                    <>
                        {/* <div className="sejaRevendedora">
                            <button onClick={openCadastro}>Cadastre-se AGORA!</button>
                        </div> */}
                        <div className="areaLogin">
                            <div className="avatar">
                                <img src={avatar} alt="leka" />
                            </div>
                            <div className="login">
                                <div className="title">
                                    <span className="material-icons">face</span> &nbsp;Área da consultora
                                </div>
                                <div className="fields">
                                    <form onSubmit={handleSubmit(sendData)}>
                                        <input name="cpf" ref={register({ required: true })} placeholder="CPF" type="text" />
                                        <input name="senha" ref={register({ required: true })} placeholder="Senha" type="password" />
                                        <button type="submit">Entrar</button>
                                    </form>
                                </div>
                                <div className="links">
                                    <Link to="/esqueceu-senha">Esqueci minha senha</Link>
                                    <Link to="/cadastro">Quero me cadastrar</Link>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {profile._id &&
                    <div className="areaLogin">
                        <div className="avatar">
                            <img src={avatar} alt="leka" />
                        </div>
                        <div className="login logado">
                            <div className="title">
                                <span className="material-icons">face</span> &nbsp;Área da consultora
                        </div>
                            <div className="fields">
                                <span>Olá {profile.nome}</span>
                                <button onClick={() => { history.push('/painel/home') }}>Painel</button>
                                <button onClick={() => { logout() }}>Sair</button>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </div>
    );
};

export default Header;